module.exports = __webpack_public_path__ + "static/media/gcdef_10045.1bc9ddda.ico";